import storeManager from '../../store/StoreManager';

const transitionsUtils = {
    TRANSITION_DURATION: 1000, // 1 second
    SLIDE_MINIM_DURATION: 1000, // 1 second

    WIPE_LEFT: 'wipeLeft',
    PATTERN_SQUARE: 'patternSquare',
    FLY_EYE: 'flyEye',
    PATTERN_DOT_LARGE: 'patternDotLarge',
    RADIAL: 'radial',
    GRID_CIRCLE: 'gridCircle',
    ANIMATION_BIRDS: 'animationBirds',
    ANIMATION_RAINBOW: 'animationRainbow',
    ANIMATION_ORNAMENTAL_FORM: 'animationOrnamentalForm',
    CROSS_FADE: 'crossFade',
    D_TILE_HORIZONTAL: '3dTileHorizontal',
    PATTERN_STARE: 'patternStare',
    SWAP: 'swap',
    D_FLIP_VERTICAL: '3dFlipVertical',
    FADE_WHITE: 'fadeThroughWhite',
    ANIMTAION_CURTAINS: 'animationCurtains',
    GRID_SLIDING: 'gridSliding',
    PATERN_CROSS: 'patternCross',
    CROSS_HATCH: 'crossHatch',
    ANIMATION_PARASOL: 'animationParasol',
    RIPPLE: 'ripple',
    SLIDE: 'slide',
    GRID_SEQUENTIAL: 'gridSequential',
    GRID_FALLING: 'gridFalling',
    PATTERN_BUBBLE: 'patternBubble',
    D_HORIZONTAL_FLIP: '3dFlipHorizontal',
    PATTERN_DIAMOND: 'patternDiamond',
    PUZZLE_RIGHT: 'puzzleRight',
    DIRECTIONAL_WIPE: 'directionalWipe',
    PATTERN_BLOCK: 'patternBlock',
    WIPE_UP: 'wipeUp',
    PATTERN_ORIENTAL: 'patternOriental',
    ANIMATION_FILM_STRIP: 'animationFilmstrip',
    GRID_DIAGONAL: 'gridDiagonal',
    ATMOSPHERIC: 'atmospheric',
    FADE_BLACK: 'fadeThroughBlack',
    PATTERN_LINE: 'patternLine',
    MOSAIC: 'mosaic',
    PAPER_PLANE: 'animationPaperPlane',
    D_CUBE_HORIZONTAL: '3dCubeHorizontal',
    CROSS_DISOLVE: 'crossDissolve',
    WIPE_DOWN: 'wipeDown',
    GRID_RANDOM: 'gridRandom',
    BURN: 'burn',
    WIPE_RIGHT: 'wipeRight',
    D_CUBE_VERTICAL: '3dCubeVertical',
    PAGE_CURL: 'pageCurl',
    D_TILE_VERTICAL: '3dTileVertical',
    PATTERN_DOT_SMALL: 'patternDotSmall',
    CROSS_ZOOM: 'crossZoom',

    exportPropertiesFromPortal: undefined,

    useTransitions() {
        const exportProperties = this.getExportProperties();

        if (exportProperties && exportProperties.addTransitions)
            return true;
        else
            return false;
    },
    getTransition() {
        const exportProperties = this.getExportProperties();

        if (exportProperties && exportProperties.useRandom) {
            var array = [this.CROSS_ZOOM, this.D_TILE_VERTICAL, this.WIPE_LEFT, this.MOSAIC, this.D_HORIZONTAL_FLIP, this.D_CUBE_VERTICAL, this.CROSS_DISOLVE, this.RADIAL, this.BURN, this.RIPPLE, this.SLIDE];
            var item = array[Math.floor(Math.random() * array.length)];

            return item;
        } else {
            return this.CROSS_FADE;
        }
    },
    useKenBurns() {
        const exportProperties = this.getExportProperties();

        if (exportProperties && exportProperties.addKenBurns)
            return true;
        else
            return false;
    },
    getExportProperties() {
        const state = storeManager.getState();
        var exportProperties = state.production.exportProperties;

        if (this.exportPropertiesFromPortal && (typeof this.exportPropertiesFromPortal === 'string' || this.exportPropertiesFromPortal instanceof String) && this.exportPropertiesFromPortal.indexOf('StartExport_') != -1) { // it's Portal export
            exportProperties = {};

            var array = this.exportPropertiesFromPortal.split('_');
            var selection = array[1];

            if (selection && selection.length == 4) {
                if (selection.charAt(0) == '1')
                    exportProperties.addKenBurns = true;
                else
                    exportProperties.addKenBurns = false;

                if (selection.charAt(1) == '1')
                    exportProperties.addTransitions = true;
                else
                    exportProperties.addTransitions = false;

                if (selection.charAt(2) == '1')
                    exportProperties.useCrossFade = true;
                else
                    exportProperties.useCrossFade = false;

                if (selection.charAt(3) == '1')
                    exportProperties.useRandom = true;
                else
                    exportProperties.useRandom = false;
            }
        }

        return exportProperties;
    }
};

export default transitionsUtils;



/** WEBPACK FOOTER **
 ** ./src/components/utils/TransitionsUtils.js
 **/